import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { FaLocationArrow, FaSearch } from "react-icons/fa";
import 'tailwindcss/tailwind.css';
import { Tooltip } from "react-tooltip";
const GraficoUbigeo = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedYear, setSelectedYear] = useState("2024");
    const [sortConfig, setSortConfig] = useState(null);

    const headersMap = {
        "UBIGEO": "Departamento",
        "CODUBIGEO": "Codigo",
        "CANTIDAD_CLIENTES": "Cantidad de Clientes",
        "CANTIDAD_EMBARQUES": "Cantidad de embarques",
        "PORCENTAJE_CLIENTES": "% de clientes",
        "PORCENTAJE_EMBARQUES": "% de embarques",
    };

    const handleShowModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    const handleYearChange = (event) => setSelectedYear(event.target.value);

    const fetchData = () => {
        setLoading(true);
        fetch(`https://msoftperu.azurewebsites.net/home/GetUbigeo?intAnio=${selectedYear}`)
            .then((response) => response.json())
            .then((data) => {
                setData(data);
                setLoading(false);
            })
            .catch((error) => {
                setError(error.message);
                setLoading(false);
            });
    };

    // Cargar los datos al ingresar automáticamente
    useEffect(() => {
        fetchData();
    }, [selectedYear]);

    const sortData = (key) => {
        let direction = 'asc';
        if (sortConfig && sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }

        const sortedData = [...data].sort((a, b) => {
            if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
            if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
            return 0;
        });

        setSortConfig({ key, direction });
        setData(sortedData);
    };

    return (
        <div className="p-4">
<button
    data-tooltip-id="buscar-tooltip"
    data-tooltip-content="Ubigeo"
    className="bg-blue-600 hover:bg-blue-800 text-white font-bold py-2 px-4 rounded-lg"
    onClick={handleShowModal}
>
    <FaLocationArrow />
</button>
<Tooltip id="buscar-tooltip" />
            

            <Modal show={showModal} onHide={handleCloseModal} size="xl" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Tabla de Ubigeo</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <div className="flex items-center mb-4 space-x-3">
                        {/* Select del año */}
                        <Form.Control
                            as="select"
                            value={selectedYear}
                            onChange={handleYearChange}
                            className="border border-gray-300 rounded w-1/5 p-2"
                        >
                            <option value="2020">2020</option>
                            <option value="2021">2021</option>
                            <option value="2023">2023</option>
                            <option value="2024">2024</option>
                            <option value="2025">2025</option>
                        </Form.Control>
                        {/* Icono de FaLocationArrow para buscar */}
                        <FaSearch
                            className="text-blue-500 text-2xl cursor-pointer"
                            onClick={fetchData}
                        />
                    </div>

                    {/* Mostrar mensaje de carga */}
                    {loading && <div className="text-center my-4">Cargando datos...</div>}

                    {!loading && data.length > 0 && (
                        <table className="table-auto w-full border-collapse">
                            <thead>
                                <tr>
                                    {Object.keys(headersMap).map((key) => (
                                        <th
                                            key={key}
                                            onClick={() => sortData(key)}
                                            className="px-4 py-2 cursor-pointer text-left border-b"
                                        >
                                            {headersMap[key]}{" "}
                                            {sortConfig && sortConfig.key === key ? (
                                                sortConfig.direction === "asc" ? "🔼" : "🔽"
                                            ) : ""}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((row, index) => (
                                    <tr key={index} className="border-b">
                                        {Object.keys(headersMap).map((key) => (
                                            <td key={key} className="px-4 py-2">
                                                {row[key]}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}

                    {error && <div className="text-center text-red-500 my-4">{error}</div>}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>Cerrar</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default GraficoUbigeo;
